<template>
  <div class="project-list" v-smooth-appear="{elements: '.smooth-appear-project', wait: 1000, duration: 600, delay: 100, translate: 30}">
    <div class="item-wrapper smooth-appear-project" v-for="(item, index) in items" :key="index">
      <a :href="item.url" class="item" target="_blank">
        <img :src="item.thumbnail" class="thumbnail">
        <div class="info">
          <h3 class="title">
            {{item.title}}
          </h3>
          <h4 class="subtitle">
            {{item.subtitle}}
          </h4>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import SmoothAppear from '@/directives/SmoothAppear'

export default {
  props: ['items'],
  directives: {
    SmoothAppear
  }
}
</script>

<style scoped>

.project-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}
.item-wrapper {
  margin: 20px;
  flex: 1 1 0;
}
.item {
  display: block;
  text-decoration: none;
  box-shadow: rgba(34, 43, 80, 0.15) 0 0 50px;
  border-radius: 10px;
  padding: 15px;

  display: flex;
  align-items: flex-start;
  transition: all 0.5s ease;
}
.item:hover {
  box-shadow: rgba(34, 43, 80, 0.15) 0 20px 100px;
  transform: scale(1.05) translateY(-5px);
}
.thumbnail {
  height: 60px;
  border-radius: 12px;
  width: auto;
}
.info {
  text-align: left;
  margin-left: 15px;
}
.title, .subtitle {
  margin: 0;
}
.title {
  font-size: 15px;
  font-weight: 300;
  font-weight: 600;
  color: #555;
  white-space: nowrap;
}
.subtitle {
  margin-top: 5px;
  font-size: 13px;
  font-weight: 300;
  color: #333;
}
</style>



// WEBPACK FOOTER //
// ProjectList.vue?76619182